import {
    fetchedAccountSummary,
    failedFetchAccountSummary,
    fetchedAccountStatement,
    failedFetchAccountStatement,
    fetchedFacilityAccountOpenInvoices,
    failedFetchAccountOpenInvoices
} from "store/actions";
import { takeLatest, put, call, fork } from "redux-saga/effects";
import AccountViewService from "services/account-view-services";
import {
    message
} from "antd";
import { ACCOUNT_VIEW_ACTIONS } from "constants/actions";


function* fetchAccountSummary({payload: { caseId }}) {
    try{
        const {data, error} = yield call(AccountViewService.getAccountSummary, caseId);
        if(!error) {
            yield put(fetchedAccountSummary(caseId, data));
        } else {
            yield put(failedFetchAccountSummary(error));
        }
    } catch(error) {
        if(error.response.status >= 500) {
            message.error("Internet Connectivity Issue. Try Again");
        }
        yield put(failedFetchAccountSummary(error));
    }
}

function* fetchAccountStatement({payload: { caseId, startDate, endDate }}) {
    try{
        const {data, error} = yield call(AccountViewService.getAccountStatement, caseId, startDate, endDate);
        if(!error) {
            yield put(fetchedAccountStatement(caseId, data));
        } else {
            yield put(failedFetchAccountStatement(error));
        }
    } catch(error) {
        if(error.response.status >= 500) {
            message.error("Internet Connectivity Issue. Try Again");
        }
        yield put(failedFetchAccountStatement(error));
    }
}

function* fetchFacilityAccountOpenInvoicesHandler({ payload: { caseId } }) {
    try {
        const { data, error } = yield call(
            AccountViewService.getOpenInvoices,
            caseId
        );

        if(!error) {
            yield put(fetchedFacilityAccountOpenInvoices(caseId, data));
            return;
        }
        yield put(failedFetchAccountOpenInvoices(caseId, error));

    } catch(error) {
        yield put(failedFetchAccountOpenInvoices(caseId, error));
    }
}

export default fork (function*() {
    yield takeLatest(
        ACCOUNT_VIEW_ACTIONS.FETCH_ACCOUNT_SUMMARY,
        fetchAccountSummary
    );
    yield takeLatest(
        ACCOUNT_VIEW_ACTIONS.FETCH_ACCOUNT_STATEMENT,
        fetchAccountStatement
    );
    yield takeLatest(
        ACCOUNT_VIEW_ACTIONS.FETCH_FACILITY_ACCOUNT_OPEN_INVOICES,
        fetchFacilityAccountOpenInvoicesHandler
    );
});